import React, { useState, useContext, useEffect } from 'react';
import './CountryOverlays.css';
import OverlayModal from './OverlayModal';
import DotLoader from '../Dotloader/Dotloader';
import { COUNTRYLISTCOMPONENT } from '../../utils/constants';
import { fetchCountryList } from '../../services/LineTableService';
import { LineTableBasicPropConfig } from '../../services/LineTableBasicPropConfig';
import { Col, Container, Row } from 'react-bootstrap';

interface CountryOverlaysSchema {
  linkText: string;
  product: any;
  metadata: any;
  modalTriggered?: () => void;
  reuseableLineTable?: boolean;
}
const CountryOverlays: React.FC<CountryOverlaysSchema> = ({
  linkText,
  product,
  metadata,
  modalTriggered,
  reuseableLineTable
}) => {
  const [modalState, setModalState] = useState(false);
  const [overlay, setOverlay] = useState([]);
  const [showLoader, setShowLoader] = useState<boolean>(true);
  const TTL = 24 * 60 * 60 * 1000;
  const [colLength, setColLength] = useState<number | any>();
  const [countryOverlayList, setCountryOverlayList] = useState([]);
  const data = product?.testProductReference?.[0]?.reference
    ? product?.testProductReference?.[0]?.reference
    : product?.reference;
  const handleClick = () => {
    setModalState(!modalState);
    if (typeof modalTriggered == 'function') modalTriggered();
    const check1 = data?.content?.body?.[0]?.countryList?.cached_url
      ? data?.content?.body?.[0]?.countryList?.cached_url?.replace(metadata?.lang, '')
      : data?.replace(metadata?.lang, '');
    const check2 = check1?.replace('//', '');
    const endPoint = reuseableLineTable
      ? LineTableBasicPropConfig?.getInstance()?.getSBUrl()
      : LineTableBasicPropConfig?.getInstance()?.getBaseUrl();
    const url = `${endPoint}rest/cms/stories/?by_slugs=${check2}`;
    const name = data?.name;
    fetchCountryList(name, metadata?.lang, url, TTL).then((data: any) => {
      if (data && data.length > 0) {
        setOverlay(data);
      }
      setShowLoader(false);
    });
  };

  useEffect(() => {
    if (overlay && overlay.length > 0) {
      overlay.map((o: any) => {
        o?.content?.body.map((b: any) => {
          if (b?.component == COUNTRYLISTCOMPONENT) {
            setCountryOverlayList(b?.countryValues);
          }
        });
      });
    }
  }, [overlay]);
  let countryListLength: number;

  useEffect(() => {
    if (countryOverlayList?.length > 0) {
      countryListLength = countryOverlayList.length;
      setColLength(Math.ceil(countryListLength / 3));
    }
  }, [countryOverlayList]);

  const closeHandler = () => {
    setModalState(false);
    if (typeof modalTriggered == 'function') modalTriggered();
  };
  return (
    <>
      <OverlayModal modalState={modalState} handler={closeHandler} overlay={overlay}>
        {showLoader && <DotLoader keyParams='loading' />}
        {!showLoader && (
          <>
            <Container className='linetable-countryOverlay-desktopView'>
              <div>
                <Row className='linetable-countryOverlay-utils-noWrap'>
                  <Col className='linetable-countryOverlay-utils-colWidth'>
                    <Row>
                      {countryOverlayList.slice(0, colLength).map((ele: any, i) => {
                        return (
                          <div
                            className='linetable-countryOverlay-contain'
                            key={ele.name ? ele.name : i}
                          >
                            <div>
                              <img
                                src={ele.icon.filename}
                                alt=''
                                className='linetable-countryOverlay-image'
                              />
                            </div>
                            <div className='linetable-countryOverlay-name'>{ele.name}</div>
                          </div>
                        );
                      })}
                    </Row>
                  </Col>

                  <Col className='linetable-countryOverlay-utils-colWidth'>
                    <Row>
                      {countryOverlayList.slice(colLength, 2 * colLength).map((ele: any, i) => {
                        return (
                          <div
                            className='linetable-countryOverlay-contain'
                            key={ele.name ? ele.name : i}
                          >
                            <div>
                              <img
                                src={ele.icon.filename}
                                alt=''
                                className='linetable-countryOverlay-image'
                              />
                            </div>
                            <div className='linetable-countryOverlay-name'>{ele.name}</div>
                          </div>
                        );
                      })}
                    </Row>
                  </Col>

                  <Col className='linetable-countryOverlay-utils-colWidth'>
                    <Row>
                      {countryOverlayList.slice(2 * colLength, 3 * colLength).map((ele: any, i) => {
                        return (
                          <div
                            className='linetable-countryOverlay-contain'
                            key={ele.name ? ele.name : i}
                          >
                            <div>
                              <img
                                src={ele.icon.filename}
                                alt=''
                                className='linetable-countryOverlay-image'
                              />
                            </div>
                            <div className='linetable-countryOverlay-name'>{ele.name}</div>
                          </div>
                        );
                      })}
                    </Row>
                  </Col>
                </Row>
              </div>
            </Container>
            <Container className='linetable-countryOverlay-mobView'>
              <Row>
                <Col>
                  <Row>
                    {countryOverlayList.map((ele: any, i) => {
                      return (
                        <div
                          className='linetable-countryOverlay-contain'
                          key={ele.name ? ele.name : i}
                        >
                          <div>
                            <img
                              src={ele.icon.filename}
                              alt=''
                              className='linetable-countryOverlay-image'
                            />
                          </div>
                          <div className='linetable-countryOverlay-name'>{ele.name}</div>
                        </div>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            </Container>
          </>
        )}
      </OverlayModal>

      <span
        onClick={handleClick}
        className={`linetable-countryOverlay-linkTextNew display-5 ${
          reuseableLineTable && 'reusbablelnetable-margin'
        }`}
      >
        {linkText}
      </span>
    </>
  );
};
export default CountryOverlays;
